export class PanelTypeOption {
    public Label: string;
    public Type: string;
    public Enabled: boolean;
    constructor(type: string, label: string, enabled: boolean) {
        this.Type = type;
        this.Enabled = enabled;
        this.Label = label;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/browse/models/panel-type-option.ts